<!-- Created by Alex Poh. on 12/04/20.-->
<!-- Copyright © 2020 Curriculum Ltd. All rights reserved.-->

<div id="canvas-container">
  <curr-button [variant]="'text'" [icon]="'clear'" (btnClick)="clear()" class="clear-btn">CLEAR </curr-button>

</div>
